import { TwoFactorComponent } from './two-factor/two-factor.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { LoginLayoutComponent } from './login-layout.component';
import { ActivationComponent } from './activation/activation.component';
import { SsoLoginResolver } from './resolvers/sso-login.resolver';
import { SsoCallbackResolver } from './resolvers/sso-callback.resolver';

export const loginRoutes = [
  {
    path: 'auth',
    component: LoginLayoutComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'login/sso',
        component: LoginComponent,
        resolve: {
          ssoLogin: SsoLoginResolver,
        },
      },
      {
        path: 'login/sso/callback',
        component: LoginComponent,
        resolve: {
          ssoCallback: SsoCallbackResolver,
        },
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
      },
      {
        path: 'reset-password/:token/:email',
        component: ResetPasswordComponent,
      },
      {
        path: 'reset-password/:token',
        component: ResetPasswordComponent,
      },
      {
        path: 'two-factor',
        component: TwoFactorComponent,
      },
      {
        path: 'activation/:token/:email',
        component: ActivationComponent,
      },
    ],
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild([])],
  exports: [RouterModule],
  providers: [SsoLoginResolver, SsoCallbackResolver],
})
export class LoginRoutingModule {
}
